import React from "react";
import Button from "../../../../components/ACS-Dashboard/ACS-Blocks/Button";

const ROW_STATUS_BADGE_CLASS = {
  UPDATED: "bg-emerald-100 dark:bg-emerald-900/40 text-black dark:text-emerald-200",
  SKIPPED: "bg-gray-100    dark:bg-gray-700/40    text-black dark:text-gray-200",
  FAILED:  "bg-red-100     dark:bg-red-900/40     text-black dark:text-red-200",
};

const downloadReportCsv = (executeResult) => {
  const lines = [["Row", "Status", "Record", "Message"].join(",")];
  executeResult.rows.forEach((r) => {
    lines.push(
      [r.rowIndex + 1, r.status, r.recordLabel || "", (r.message || "").replace(/,/g, ";")]
        .map((v) => `"${String(v).replace(/"/g, '""')}"`)
        .join(",")
    );
  });
  const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "location-bulk-update-report.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

const ExecuteResultsStep = ({ executeResult, onDone, onStartOver }) => (
  <div className="flex flex-col gap-fluid-3">
    <div className="grid grid-cols-3 gap-fluid-2">
      <div className="border border-gray-200 dark:border-acs-dark-border rounded-lg p-fluid-2 bg-white dark:bg-acs-dark-surface">
        <div className="text-fluid-xl font-bold text-emerald-700 dark:text-emerald-300">{executeResult.updatedCount}</div>
        <div className="text-fluid-xs text-gray-500 dark:text-acs-dark-subtext">Updated</div>
      </div>
      <div className="border border-gray-200 dark:border-acs-dark-border rounded-lg p-fluid-2 bg-white dark:bg-acs-dark-surface">
        <div className="text-fluid-xl font-bold text-gray-700 dark:text-acs-dark-subtext">{executeResult.skippedCount}</div>
        <div className="text-fluid-xs text-gray-500 dark:text-acs-dark-subtext">Skipped</div>
      </div>
      <div className="border border-gray-200 dark:border-acs-dark-border rounded-lg p-fluid-2 bg-white dark:bg-acs-dark-surface">
        <div className="text-fluid-xl font-bold text-red-700 dark:text-red-300">{executeResult.failedCount}</div>
        <div className="text-fluid-xs text-gray-500 dark:text-acs-dark-subtext">Failed</div>
      </div>
    </div>

    <div className="overflow-x-auto border border-gray-200 dark:border-acs-dark-border rounded-lg max-h-[45vh] overflow-y-auto">
      <table className="min-w-full text-fluid-sm">
        <thead className="bg-gray-50 dark:bg-acs-dark-bg text-gray-500 dark:text-acs-dark-subtext sticky top-0">
          <tr>
            <th className="text-left px-3 py-2 font-semibold">Row</th>
            <th className="text-left px-3 py-2 font-semibold">Status</th>
            <th className="text-left px-3 py-2 font-semibold">Record</th>
            <th className="text-left px-3 py-2 font-semibold">Message</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100 dark:divide-acs-dark-border">
          {executeResult.rows.map((row) => (
            <tr key={row.rowIndex} className="bg-white dark:bg-acs-dark-surface">
              <td className="px-3 py-2 text-gray-500 dark:text-acs-dark-subtext">{row.rowIndex + 1}</td>
              <td className="px-3 py-2">
                <span className={`text-fluid-xs px-fluid-1.5 py-fluid-1 rounded font-medium ${ROW_STATUS_BADGE_CLASS[row.status]}`}>
                  {row.status}
                </span>
              </td>
              <td className="px-3 py-2 text-gray-800 dark:text-acs-dark-text">{row.recordLabel || "—"}</td>
              <td className="px-3 py-2 text-gray-500 dark:text-acs-dark-subtext">{row.message || "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    <div className="flex justify-between">
      <div className="flex gap-fluid-2">
        <Button
          text="Download Report"
          variant="outline"
          onClick={() => downloadReportCsv(executeResult)}
          className="!w-auto whitespace-nowrap !px-fluid-4"
        />
        <Button
          text="Run Another Upload"
          variant="outline"
          onClick={onStartOver}
          className="!w-auto whitespace-nowrap !px-fluid-4"
        />
      </div>
      <Button text="Done" onClick={onDone} />
    </div>
  </div>
);

export default ExecuteResultsStep;
